import { IOrderData } from '../model/types'

const redirectEmptyOrderForTips = (order: IOrderData, emptyOrder: boolean, url: string) => {
  const hasWaiter = order && order.waiter && order.waiter.name && order.waiter.card_verification
  const hasFamily = !Array.isArray(order?.team)

  if (!hasWaiter && !hasFamily && emptyOrder) {
    window.location.href = url
  }
}

export default redirectEmptyOrderForTips
